import React, { memo } from 'react'
import Card from '@mui/material/Card'
import { isEmpty } from 'lodash'
import { makeStyles } from 'tss-react/mui'
import { keyframes } from 'tss-react'
import { Typography } from '@mui/material'

const useStyles = makeStyles()(theme => ({
  container: {
    display: 'flex',
    flexGrow: '1',
    zIndex: '3',
    flexDirection: 'column',
    animation: `${keyframes`
      from {
        transform: scale(0);
      }
      to {
        transform: scale(1);
      }
    `} 0.5s cubic-bezier(0.7, 0, 0, 1)`,
    transformOrigin: 'top center',
  },
  header: {
    marginBottom: theme.spacing(4),
    marginLeft: theme.spacing(4),
    marginTop: theme.spacing(4),
    [theme.breakpoints.down('md')]: {
      margin: 0,
      paddingLeft: theme.spacing(2),
      lineHeight: '48px',
      height: 48,
      verticalAlign: 'middle',
    },
  },
  form: {
    width: '100%',
  },
}))

export interface IPageWrapperProps {
  title?: string
  noAnim?: boolean
  style?: React.CSSProperties
  titleStyle?: React.CSSProperties
  cardStyle?: React.CSSProperties
  children?: React.ReactElement | React.ReactElement[]
  withoutCard: boolean
  raised?: boolean
  ['data-cy']?: string
}

/**
 * @deprecated Use the Page and Page* components from components instead for old/centralized layouts, and the Page* components from components/Layouts/V3 for sidebar based layouts instead.
 */
function PageWrapper(props: IPageWrapperProps) {
  const {
    title,
    noAnim,
    style = {},
    titleStyle = {},
    cardStyle = {},
    children,
    withoutCard,
    raised,
  } = props
  const { classes } = useStyles()

  const renderContent = () => {
    if (isEmpty(children)) return null

    if (withoutCard) {
      return (
        <div className={classes.form}>
          {children}
        </div>
      )
    }

    return (
      <Card className={classes.form} style={cardStyle} raised={raised}>
        {children}
      </Card>
    )
  }

  return (
    <div className={classes.container} style={noAnim ? { animation: 'none', ...style } : style} data-cy={props['data-cy'] || 'page-wrapper'}>
      {title && (
        <Typography variant="h3" className={classes.header} style={titleStyle}>{title}</Typography>
      )}

      {renderContent()}
    </div>
  )
}

export default memo(PageWrapper)
